/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_MobileInputs */

const en_gc_editor_mobile = /** @type {(inputs: Gc_Editor_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A desktop browser and keyboard give you the best spreadsheet experience. You can still try it here.`)
};

const zh_gc_editor_mobile = /** @type {(inputs: Gc_Editor_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在桌面浏览器上搭配键盘使用体验更佳，也可以直接在此试用。`)
};

/**
* | output |
* | --- |
* | "A desktop browser and keyboard give you the best spreadsheet experience. You can still try it here." |
*
* @param {Gc_Editor_MobileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_mobile = /** @type {((inputs?: Gc_Editor_MobileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_MobileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_mobile(inputs)
	return zh_gc_editor_mobile(inputs)
});
export { gc_editor_mobile as "gc.editor.mobile" }